<template>
    <div class="col-md-6">
        <label class="attribute-label m-bottom-12">   {{ depositLabel }}</label>
        <div class="input-group width-100">
            <input type="number"  step="0.01" name="deposit" id="deposit" class="form-control price-new-inputs"   @update="update($event)" :readonly="mergedInvoice" v-model="deposit" >
            <span class="input-group-addon input-group-addon-new-design" style="background-color: #F5F5F6 !important;">
                <b> {{ currency.currency_symbol }} </b>
            </span>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
export default {
    name: "BookingDepositField",
    props: ['value','currency','mergedInvoice','paidAmount'],
    data(){
        return {
            deposit: this.value
        }
    },
    computed: {
        depositLabel() {
            // Determine label based on `paidAmount` and `totalDeposit`
            return this.paidAmount >= this.deposit ? 'Deposit Paid' : 'Deposit Required';
        }
    },
    methods:{
        update(event){
            this.deposit = event.target.value.toFixed(2)
        },

    },
    mounted(){
      EventBus.$on('onDepositUpdated', (value) => {
        this.deposit = Number(value);
      })
    },
    watch:{
        value(value){
          this.deposit = +value.toFixed(2)
        },
        deposit(value){
            this.$emit('input',+value)
        }
    }
}
</script>

<style scoped>

</style>